import { VStack, Text, Box } from '@chakra-ui/react'
import React from 'react'

const EventCityBarbecue: React.FC = () => (
  <VStack spacing={4} align='stretch'>
    <Text fontSize='lg' fontWeight='bold'>
      Sunday, November 2, 2024
    </Text>
    <Text>11 AM - 8 PM</Text>
    <Text>
      Join us at City Barbecue in Florence, KY for a fundraiser! Just mention{' '}
      <Box as='span' fontFamily='Cherry Swash' color='blue.500'>
        Shine Like Lauren
      </Box>{' '}
      when you order!
    </Text>
    <Box>
      <Text fontWeight='bold' mb={2}>
        Available options:
      </Text>
      <Text>• Dine-In</Text>
      <Text>• Takeout</Text>
      <Text>• Drive-Thru</Text>
    </Box>
  </VStack>
)

export default EventCityBarbecue
